module.exports = "/*------------------------\r\n        VARIABLES\r\n -------------------------*/\n"